export const INTERACTION_OVERLAY_SIZES = {
	SM: 'sm',
	MD: 'md',
	LG: 'lg',
};

export const VIDEO_INTERACTION_OVERLAY_CONFIG = {
	[INTERACTION_OVERLAY_SIZES.SM]: { min: 0, max: 723 },
	[INTERACTION_OVERLAY_SIZES.MD]: { min: 724, max: 1023 },
	[INTERACTION_OVERLAY_SIZES.LG]: { min: 1024, max: Infinity },
};
